import React from 'react';
import './style';
import { Button } from 'app/components';

const Footer = (props) => {
  const {
    onClickBack,
    onClickNext,
    showPublish,
    isPrimaryButtonDisabled,
  } = props;

  return (
    <footer className="footer-container flex py-4 bg-white justify-center">
      <div className="button-container flex items-center justify-between">
        <Button
          type="tertiary-text-underlined"
          onClick={onClickBack}
        >
          Back
        </Button>
        <Button
          onClick={onClickNext}
          disabled={isPrimaryButtonDisabled}
        >
          {showPublish ? 'Publish event now' : 'Next'}
        </Button>
      </div>
    </footer>
  );
};

export default Footer;
